export enum EventType {
  WHATSAPP = 'WHATSAPP',
}
